import { PhoneNumber } from 'utils';
import * as Yup from 'yup';
import {
  DocumentSendFormAdditionalFields,
  DocumentSendFormModalFields,
} from './document-send-form-modal-container';

export default (
  additionalFields?: DocumentSendFormAdditionalFields,
): Yup.ObjectSchema<DocumentSendFormModalFields> =>
  Yup.object().shape({
    givenName: additionalFields?.givenName
      ? Yup.string().required('Prénom requis !')
      : Yup.string(),
    familyName: additionalFields?.familyName
      ? Yup.string().required('Nom requis !')
      : Yup.string(),
    telephone: Yup.string()
      .required('Numéro de téléphone requis !')
      .test('is-valid', 'Numéro de téléphone invalide !', PhoneNumber.isValid),
    proReceiptEmail: Yup.string()
      .required('mail requis !')
      .email('Adresse email non valide !'),
  });
